import { render } from "./NetworkPresence.vue?vue&type=template&id=c0b45048&scoped=true"
import script from "./NetworkPresence.vue?vue&type=script&lang=js"
export * from "./NetworkPresence.vue?vue&type=script&lang=js"

import "./NetworkPresence.vue?vue&type=style&index=0&id=c0b45048&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0b45048"]])

export default __exports__